/* eslint-disable import/prefer-default-export */
import { ref } from "vue";
import { defineStore } from "pinia";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import useFormValidation from "@/composables/validations/useFormValidation";
import filters from "@/composables/store/filters";

const { validateEmailField, validateMobileField, validateCheckboxField } =
  useFormValidation();

const { checkLocalStorage, bindLocalStorage } = useLocalStorage();
const { formHasErrors, getErrorByField, getFormPayload } = filters();

const formObject = {
  email: {
    value: null,
    error: null,
    validator: validateEmailField,
    required: true,
  },
  country: {
    value: "United States",
    required: true,
  },
  mobile: {
    value: null,
    required: true,
    validator: validateMobileField,
    error: "",
  },
  phoneCountry: {
    value: "US",
    required: true,
  },
  internationalCode: {
    value: "+1",
    required: true,
  },
  marketing: {
    value: null,
  },
  tnc: {
    value: null,
    error: null,
    validator: validateCheckboxField,
    required: true,
  },
  consumerReport: {
    value: null,
    error: null,
    required: true,
    validator: validateCheckboxField,
  },
};

export const useVerificationStore = defineStore({
  id: "verification",
  state: () => ({
    form: checkLocalStorage("verification", formObject),
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
    getFormPayload: (store) => store.form && getFormPayload(store),
  },
  actions: {
    updateValue(field, val) {
      if (!Object.getOwnPropertyDescriptor(this.form, field)) {
        return;
      }

      if (Object.getOwnPropertyDescriptor(this.form[field], "validator")) {
        const { validator } = this.form[field];
        if (field === "mobile") {
          this.form.mobile.error = validator(val, this.form.phoneCountry.value);
        } else {
          this.form[field].error = validator(field, val);
        }
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
    removeField(field) {
      if (!Object.getOwnPropertyDescriptor(this.form, field)) {
        return;
      }
      delete this.form[field];
      bindLocalStorage(this.$id, this.form);
    },
    reAddField(field) {
      if (!Object.getOwnPropertyDescriptor(this.form, field)) {
        this.form[field] = formObject[field];
        bindLocalStorage(this.$id, this.form);
      }
    },
  },
});
